import fetcher from '../fetcher';
import { useQuery } from '@tanstack/react-query';

export interface MonitoringPipelineGoliveRequest {
	[key: string]: unknown;
	/**
	 * Filter (Jenis Plafon):
	 * 0 = Joint Financing
	 * 1 = Non Joint Financing
	 * null = All
	 */
	plafondType?: number | null;
	/**
	 * Filter (FBDH):
	 * User ID of the selected FBDH
	 * null = All
	 */
	fbdhId?: number | null;
}

export interface MonitoringPipelineGoliveDetailItem {
	purchaseOrderNo?: string;
	creditSimulationNo?: string;
	ntfAmount?: number;
	unit?: number;
	createdAt: string;
	releaseDate?: string;
	originalStatus?: string;
	step?: string; // "Cetak PO" or "Proses Pencairan"
	plafonType?: string; // "JF" or "NJF"
}

export interface MonitoringPipelineGoliveItem {
	fbdhName: string;
	details?: MonitoringPipelineGoliveDetailItem[];

	// Total Last Month
	totalLastMonthCetakPo: number;
	totalLastMonthProsesPencairan: number;

	// Total Current MTD
	totalCurrentMtdCetakPo: number;
	totalCurrentMtdProsesPencairan: number;

	// Joint Financing (Real Time)
	jfCetakPo: number;
	jfProsesPencairan: number;

	// Non Joint Financing (Real Time)
	njfCetakPo: number;
	njfProsesPencairan: number;
}

export interface MonitoringPipelineGoliveResponse {
	/** Last update timestamp */
	lastUpdate: string;
	totalEstimatedNtf: number;
	totalUnits: number;

	// List of rows per FBDH
	items: MonitoringPipelineGoliveItem[];

	// Grand Total Row (Sum of all items)
	grandTotal: MonitoringPipelineGoliveItem;
}

export const useMonitoringPipelineGoliveSearch = (
	params: MonitoringPipelineGoliveRequest,
) => {
	return useQuery({
		queryKey: ['/monitoring-pipeline-golive/search', params] as const,
		queryFn: ({ queryKey }) => {
			const [api, body] = queryKey;
			return fetcher<MonitoringPipelineGoliveResponse>({
				api,
				method: 'POST',
				body,
			});
		},
	});
};
